
<template>
    <div v-if="showModel" class="edit-model">
        <div class="img-div">
            <div>{{title}}</div>
            <div class="close-img" @click="cancel"><i class="iconfont">&#xe641;</i></div>
        </div>
       
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="学校名称" prop="school">
                <Input type="text" placeholder="" v-model="formData.school"></Input>
            </FormItem>
            <!-- <FormItem label="类型" prop="type" class="ivu-form-item-required">
                <RadioGroup v-model="formData.type">
                    <Radio label="1">小学</Radio>
                    <Radio label="2">初中</Radio>
                    <Radio label="3">高中</Radio>
                    <Radio label="4">大学</Radio>
                </RadioGroup>
            </!--> 
            <FormItem label="状态" prop="status" class="ivu-form-item-required">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">启用</Radio>
                    <Radio label="2">禁用</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="年级" prop="class_idsV" class="ivu-form-item-required">
                <SearchModelNew   v-model="formData.class_idsV" :isMultiple="1"
              :url="config.urlArray.schooClassAll"
              labelName="class_name"
              valName="id"
              keyword="keyword" placeholderText="请输入"  ></SearchModelNew>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  name: "Model1",
  components: {
  },
  data() {
    return {
      title: "添加/编辑",
      disabled: false,
      defaultData:{
        id: '',
        school: "",
        type: "1",
        status: "1",
        class_ids: "",
        class_idsV:[]
      },
      formData: {},
      ruleCustom: {
        //验证
        // title: [
        //   { required: true, message: "问题必须填写", trigger: "blur" },
        // ],
       
      },
      
    };
  },
  watch: {
    showModel(val) {
		if(val){
			if (this.type && this.type == 2) {
				this.editForm()
			}
			if(this.type && this.type == 1){
				this.formData = this.defaultData
			}
		}
    },
  },   
  methods: {
    editForm() {
	  for(let key in this.defaultData){
		  this.formData[key]=(this.editFormData[key] instanceof Array || this.editFormData[key] instanceof Object )?this.editFormData[key] : String(this.editFormData[key])
		  if(!this.editFormData[key]){
		    this.formData[key] = ''
          } 
      }
       this.formData.class_idsV = this.formData.class_ids.split(',')
       this.formData.class_idsV = this.formData.class_idsV.map((item,index)=>{
           item = Number(item)
           return item
       })
    },
    subData(name) {
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
          this.formData.class_ids = this.formData.class_idsV.join(',')
          this.axios
            .post(this.config.urlArray.schoolStore, this.formData)
            .then(result => {
              common.ajaxMsg(
                result.data,
                true,
                () => {
                  //提交表单后的回调处理
                  this.resetForm(); //重置表单
                  this.fn();
                },
                () => {
                  this.disabled = false;
                }
              );
            })
            .catch(err => {
              common.msg("error", "提交失败", () => {
                this.disabled = false;
              });
            });
        }
      });
    },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.resetForm()
      this.fn();
    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
        this.formData = this.defaultData
      //重置表单
      this.formData.id = '';
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model{
    position: relative;
    .img-div{
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 45px;
        div{
            font-weight: bold;
            font-size: 15px;
        }
    }
    .close-img{
        border: 1px solid #fd6363;
        display: inline-block;
        line-height: 100%;
        border-radius: 100%;
        padding: 5px;
        color: #f00;
        right: 10px;
        top: 10px;
        z-index: 3;
        cursor: pointer;
    }
    .close-img:hover{
        transform: scale(1.1);
        transition: all 0.3s;
    }
}
.option-div{
    padding: 10px;
    box-sizing: border-box; 
    .title{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .list{
        margin-top: 10px;
        .item{
            display: flex;
            align-items: center;
            justify-content: space-between;
            div{
                // flex: 1;
            }
            .tit{
                width: 100px;
                margin-right: 10px;
            }
            .name{
                flex: 1;
            }
            .btnq{
                width: 100px;
                display: flex;
                justify-content: flex-end;
            }
            
        }
    }
}
</style>